import styled from 'styled-components';
import { IC_CALENDAR } from '../../../Common/Assets/images/index';

export const AddNewFamilyMemberStyled = styled.div`
  width: 100%;
  .label {
    font-weight: 600;
    font-size: 16px;
  }
  .form-label {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.text.medium};
  }

  .paddingBox {
    width: 100%;
    padding: 0 24px !important;
  }

  .genderRow {
    align-items: baseline !important;
  }

  .dropdown-wrapper {
    align-items: end;

    &.errorAlignedRow {
      align-items: baseline !important;
    }

    .dropdown {
      .dropdown-toggle {
        width: 100%;
        text-align: left;
        border-radius: 8px;
        height: 52px;
      }
      .dropdown-menu {
        width: 100%;
      }
    }
  }
  .date-picker-input {
    position: relative;
    .react-calendar {
      position: absolute;
      top: 90px;
      z-index: 100;
    }
    .date_field {
      .inputField {
        background-image: url(${IC_CALENDAR.src}) !important;
        background-position: calc(100% - 18px) center;
        background-repeat: no-repeat;
        background-size: 16px;
      }
    }
    .date-icon {
      background: url(${IC_CALENDAR.src}) no-repeat;
      height: 20px;
      width: 20px;
      display: flex;
      position: absolute;
      right: 7px;
      bottom: 14px;
    }
  }

  .uploadIdLabel {
    padding-right: 0px;

    .img-sub-title {
      padding-right: 0px;

      div {
        font-weight: 600;
        font-size: 13px;
        color: ${(props) => props.theme.text.medium};
        text-align: end;
      }
    }
  }

  .invalid-feedback {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.verification.red.main};
  }
  .edit-radio-btn {
    .form-check-input[type='radio']:checked + label {
      color: ${(props) => props?.theme?.blue?.dark};
    }
  }
  @media (max-width: 767px) {
    .mobile-profile-pic {
      text-align: center;
      .profile-wrapper {
        width: 105px;
        margin: 0 auto;
      }
    }
  }
`;
